import jsPDF from 'jspdf';
import { arialNormalBase64, arialBoldBase64 } from './pdfFont';

// Arial fontunu jsPDF'e kaydet ve Türkçe destekli döküman döndür
export function createPDF(opts = {}) {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4', ...opts });

  doc.addFileToVFS('Arial-normal.ttf', arialNormalBase64);
  doc.addFont('Arial-normal.ttf', 'Arial', 'normal');

  doc.addFileToVFS('Arial-bold.ttf', arialBoldBase64);
  doc.addFont('Arial-bold.ttf', 'Arial', 'bold');

  doc.setFont('Arial', 'normal');
  return doc;
}

// autoTable için ortak stil — Arial fontu kullan
export const autoTableDefaults = {
  styles: {
    font: 'Arial',
    fontStyle: 'normal',
    fontSize: 9,
    cellPadding: 2,
  },
  headStyles: {
    font: 'Arial',
    fontStyle: 'bold',
    fillColor: [26, 35, 126],
    textColor: 255,
    fontSize: 9,
  },
  alternateRowStyles: {
    fillColor: [245, 247, 255],
  },
};
